/**
 * Returns the registrable domain (last two labels) of the current host,
 * e.g. `dispatch.horizonfreightsystem.com` -> `horizonfreightsystem.com`.
 */
export function getDomain(): string {
  return window.location.hostname.split('.').slice(-2).join('.');
}
